import { render, staticRenderFns } from "./businessStatistics.vue?vue&type=template&id=9ad56672"
import script from "./businessStatistics.vue?vue&type=script&lang=js"
export * from "./businessStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports